export default __webpack_public_path__ + "static/media/17.a5457e06.jpg";